import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import './styles/responsive.css';
import App from './App';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <HelmetProvider>
                <AuthProvider>
                    <CartProvider>
                        <Toaster
                            position="top-center"
                            toastOptions={{
                                style: { fontFamily: "'Inter', sans-serif", fontSize: 14 }
                            }}
                        />
                        <App />
                    </CartProvider>
                </AuthProvider>
            </HelmetProvider>
        </BrowserRouter>
    </React.StrictMode>
);
